import React from 'react';
import { useLanguage } from '../../assets/js/LanguageContext';
import SectionEyebrow from '../common/SectionEyebrow';
import GradientCard from '../common/GradientCard';
import { ShieldCheck, PiggyBank } from 'lucide-react';
import '../../assets/styles/SectionBand.css';
import '../../assets/styles/HomeClosing.css';

/* Los dos argumentos de cierre. Antes eran dos filas de imagen y texto
 * alternando lado; ahora dos tarjetas con el mismo peso, cada una con su
 * icono asomando por la esquina y su enlace a donde toca. */

const HomeGrid = () => {
  const { t } = useLanguage();

  const cards = [
    {
      id: 1,
      accent: '#2563EB',
      badgeText: t('home4_badge1'),
      title: t('home4_sec_title1'),
      description: t('home4_sec_text1'),
      ctaText: t('home4_cta1'),
      ctaTo: '/contact-us',
      icon: <ShieldCheck size="1em" strokeWidth={1.25} />
    },
    {
      id: 2,
      accent: '#0D9488',
      badgeText: t('home4_badge2'),
      title: t('home4_sec_title2'),
      description: t('home4_sec_text2'),
      ctaText: t('home0_cta_pricing'),
      ctaTo: '/pricing',
      icon: <PiggyBank size="1em" strokeWidth={1.25} />
    }
  ];

  return (
    <section className="section-band">
      <div className="section-band__inner">
        <div className="section-band__head">
          <SectionEyebrow>{t('home4_eyebrow')}</SectionEyebrow>
        </div>

        <div className="closing-grid">
          {cards.map((card) => (
            <GradientCard
              key={card.id}
              accent={card.accent}
              badgeText={card.badgeText}
              title={card.title}
              description={card.description}
              ctaText={card.ctaText}
              ctaTo={card.ctaTo}
              icon={card.icon}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeGrid;
